import { Box, IconButton, useTheme, useMediaQuery, InputBase, Menu, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import { useContext, useState } from "react";
import { tokens } from "../../theme";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import SearchIcon from "@mui/icons-material/Search";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import { useAuth } from "../../auth/Login";

const Topbar = ({ isSidebarOpen, toggleSidebar }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { logout, user } = useAuth();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  // State for user menu
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  
  // State for logout confirmation dialog
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

  // Handle user menu open
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // Handle user menu close
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // Handle logout button click
  const handleLogoutClick = () => {
    handleMenuClose();
    setLogoutDialogOpen(true);
  };

  // Handle logout confirmation
  const handleConfirmLogout = () => {
    setLogoutDialogOpen(false);
    logout();
  };

  // Handle logout cancellation
  const handleCancelLogout = () => {
    setLogoutDialogOpen(false);
  };

  return (
    <Box 
      display="flex" 
      justifyContent="space-between" 
      p={isMobile ? 1.5 : 2}
      flexDirection={isMobile ? "column" : "row"}
      gap={isMobile ? 1 : 0}
      sx={{ position: 'relative', zIndex: 100 }}
    >
      <Box
        display="flex"
        alignItems="center"
        width={isMobile ? "100%" : "auto"}
      >
        {isMobile && (
          <IconButton 
            onClick={toggleSidebar}
            sx={{ 
              mr: 1,
              color: colors.grey[100],
              backgroundColor: colors.primary[500],
              borderRadius: "4px",
              '&:hover': {
                backgroundColor: colors.primary[600],
              }
            }}
          >
            {isSidebarOpen ? <CloseOutlinedIcon /> : <MenuOutlinedIcon />}
          </IconButton>
        )}

        {/* SEARCH BAR */}
        {/* <Box
          display="flex"
          backgroundColor={colors.primary[400]}
          borderRadius="3px"
          width="100%"
        >
          <InputBase sx={{ ml: 2, flex: 1 }} placeholder="Search" />
          <IconButton type="button" sx={{ p: 1 }}>
            <SearchIcon />
          </IconButton>
        </Box> */}
           <Typography
        variant="h2"
        color={colors.grey[900]}
        fontWeight="bold"
        sx={{ m: "0 0 5px 0" }}
      >
      JV LANDS
      </Typography>
      </Box>

      {/* ICONS */}
      <Box display="flex" justifyContent={isMobile ? "flex-end" : "flex-start"} width={isMobile ? "100%" : "auto"}>
        {/* <IconButton>
          <SettingsOutlinedIcon />
        </IconButton> */}
        <IconButton 
          onClick={handleMenuOpen}
          aria-controls={open ? "user-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
        >
          <PersonOutlinedIcon />
        </IconButton>
        
        {/* User Dropdown Menu */}
        <Menu
          id="user-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
          MenuListProps={{
            'aria-labelledby': 'user-button',
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          PaperProps={{
            sx: {
              backgroundColor: colors.primary[400],
              mt: 1,
              boxShadow: 3,
              borderRadius: 2,
              minWidth: 120,
            }
          }}
        >
          <Typography 
            variant="body2" 
            sx={{ 
              px: 2, 
              py: 1, 
              fontWeight: 'bold',
              color: colors.grey[300],
              borderBottom: `1px solid ${colors.primary[300]}`
            }}
          >
            {user?.Username || "User"}
          </Typography>
          <MenuItem 
            onClick={handleLogoutClick}
            sx={{ 
              color: colors.grey[100], 
              display: 'flex', 
              alignItems: 'center',
              gap: 1,
              '&:hover': {
                backgroundColor: colors.primary[500],
              }
            }}
          >
            <LogoutIcon fontSize="small" />
            Logout
          </MenuItem>
        </Menu>
        
        {/* Logout Confirmation Dialog */}
        <Dialog
          open={logoutDialogOpen}
          onClose={handleCancelLogout}
          PaperProps={{
            sx: {
              backgroundColor: colors.primary[400],
              borderRadius: 2,
              boxShadow: 3,
            }
          }}
        >
          <DialogTitle sx={{ color: colors.grey[100] }}>Confirm Logout</DialogTitle>
          <DialogContent>
            <Typography variant="body1" sx={{ color: colors.grey[100] }}>
              Are you sure you want to log out of your account?
            </Typography>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button 
              onClick={handleCancelLogout} 
              sx={{ 
                color: colors.grey[300],
                '&:hover': {
                  backgroundColor: colors.primary[500],
                }
              }}
            >
              Cancel
            </Button>
            <Button 
              onClick={handleConfirmLogout} 
              variant="contained"
              sx={{ 
                backgroundColor: colors.redAccent[600],
                '&:hover': {
                  backgroundColor: colors.redAccent[700],
                }
              }}
            >
              Logout
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Box>
  );
};

export default Topbar;
